/* eslint-disable */
import React, { useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Subscription } from 'utils/apiClient/services/core/types';

const DelightedScriptElementId = 'delighted-script';

interface DelightedWindow extends Window {
  delightedNps2?: {
    survey: (config: {
      email?: string;
      properties: {
        accountId: number;
        country?: string;
        locale: string;
        subscription: string;
        source: string;
      };
    }) => void;
  };
}

const w = window as DelightedWindow;

type DelightedScriptArray = Array<{
  SNIPPET_VERSION?: string;
  [key: string]: any;
}>;

// @ts-ignore
// eslint-disable-next-line
function loadScript(
  e: Window,
  t: Document,
  r: string,
  n: string,
  x: () => void
): void {
  if (!e[n]) {
    const a: DelightedScriptArray = [];
    e[n] = a;
    const i = [
      'survey',
      'reset',
      'config',
      'init',
      'set',
      'get',
      'event',
      'identify',
      'track',
      'page',
      'screen',
      'group',
      'alias',
    ];
    // eslint-disable-next-line
    for (let s = 0; s < i.length; s++) {
      const c = i[s];
      a[c] =
        a[c] ||
        (function (e: string) {
          return function () {
            const t = Array.prototype.slice.call(arguments);
            a.push([e, t]);
          };
        })(c);
    }
    a[0] = { SNIPPET_VERSION: '1.0.1' };
    const o = t.createElement('script');
    o.id = DelightedScriptElementId;
    o.type = 'text/javascript';
    o.async = true;
    o.defer = true;
    o.src = `https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/${r}/${n}.js`;
    o.onload = x;
    const l = t.getElementsByTagName('script')[0];
    l.parentNode.insertBefore(o, l);
  }
}

interface Props {
  country?: string;
  email?: string;
  accountId?: number;
  subscriptions: Subscription[];
}

const apiKey = 'ym7ogWl6FDUMSAlY';
const api = 'delightedNps2';

const validSubscriptionIds = [
  1, 7, 9, 11, 12, 16, 17, 18, 26, 27, 28, 30, 31, 32, 246, 345, 378, 379, 380,
];

const getActivePlan = (subs: Subscription[]): string => {
  const trial = subs.find((s) => s.subscription_plan.id === 10);
  if (trial) return trial.subscription_plan.name;

  const validSub = subs.find((s) =>
    validSubscriptionIds.includes(s.subscription_plan.id)
  );
  if (validSub) return validSub.subscription_plan.name;

  return 'Other';
};

const DelightedNPSWidget: React.FC<Props> = ({
  country,
  email,
  accountId,
  subscriptions,
}) => {
  const subscription = useMemo(
    () => getActivePlan(subscriptions),
    [subscriptions]
  );

  const { locale } = useIntl();
  const startDelighted = useCallback(() => {
    if (accountId) {
      w.delightedNps2.survey({
        email,
        properties: {
          accountId,
          country,
          locale,
          subscription,
          source: 'POS Manager',
        },
      });
    }
  }, [accountId, subscription, country, locale, email]);

  useEffect(() => {
    const script = document.getElementById(DelightedScriptElementId);

    if (script) {
      startDelighted();
    } else {
      loadScript(window, document, apiKey, api, startDelighted);
    }
  }, [startDelighted]);

  return null;
};

export default DelightedNPSWidget;
